var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/radio/common/src/radio-props.ts
var radioSizes = ["sm", "md", "lg"];
var radioStatuses = ["none", "error"];
var radioDefaultProps = {
  inline: false,
  size: "md",
  status: "none",
  labelPlacement: "right"
};

// components/radio/common/src/radio-style-sheet.ts
import {
  StyleSheet
} from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var radioStyleSheet = new StyleSheet("radio", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.radio
  );
});
function createDefaultStyledClasses({
  theme,
  size,
  inline,
  labelPlacement,
  status
}) {
  const errorColors = theme.status.error;
  const borderColor = theme.border.strong;
  const borderHoverColor = theme.increaseContrast(borderColor, 1);
  const checkedIconColor = status === "error" ? errorColors.bold : theme.colorScheme.primary;
  const errorStyles = status === "error" ? {
    "&:not(:disabled)": {
      "+ span": {
        borderColor: errorColors.bold
      }
    },
    "&:focus": {
      "&:not(:disabled)": {
        "+ span": {
          borderColor: errorColors.bold
        }
      }
    }
  } : {
    "&:focus": {
      "&:not(:disabled)": {
        "+ span": {
          boxShadow: `
                                0 0 0 1px ${theme.surface.primary}, 
                                0 0 0 2px ${checkedIconColor}
                            `
        }
      }
    }
  };
  return {
    root: {
      display: inline ? "inline-flex" : "block",
      marginBottom: radioSizeVariants[size].rootMarginBottom,
      paddingBottom: radioSizeVariants[size].rootPaddingBottom,
      alignItems: inline ? "baseline" : "normal",
      marginRight: inline ? radioSizeVariants[size].inlineMarginRight : "0px"
    },
    input: __spreadValues({
      cursor: "pointer",
      transition: "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
      bottom: 0,
      left: 0,
      opacity: 0,
      position: "absolute",
      right: 0,
      top: 0,
      zIndex: 1,
      "&:hover:not(:disabled):not(:checked)": {
        "+ span": {
          borderColor: status === "error" ? errorColors.bold : borderHoverColor
        }
      },
      "&:checked + span": {
        borderColor: theme.border.contrast,
        "&::after": {
          backgroundColor: checkedIconColor
        }
      },
      "&:disabled": {
        cursor: "default"
      }
    }, errorStyles),
    container: {
      display: "inline-flex",
      order: 1
    },
    inner: {
      border: "1px solid",
      borderRadius: "50%",
      borderColor,
      boxSizing: "border-box",
      backgroundColor: theme.surface.primary,
      display: "block",
      position: "relative",
      transition: "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
      height: radioSizeVariants[size].inputHeight,
      marginRight: labelPlacement === "right" ? radioSizeVariants[size].inputMarginRight : 0,
      marginLeft: labelPlacement === "left" ? radioSizeVariants[size].inputMarginRight : 0,
      top: radioSizeVariants[size].inputTop,
      width: radioSizeVariants[size].inputWidth,
      "&::after": {
        borderRadius: "50%",
        boxSizing: "border-box",
        content: '""',
        display: "table",
        position: "absolute",
        height: radioSizeVariants[size].checkedHeight,
        left: radioSizeVariants[size].checkedLeft,
        top: radioSizeVariants[size].checkedTop,
        width: radioSizeVariants[size].checkedWidth
      }
    },
    label: {
      marginBottom: 0,
      display: "flex"
    },
    children: {
      verticalAlign: inline ? "baseline" : "top",
      order: labelPlacement === "right" ? 2 : 0
    }
  };
}
var radioSizeVariants = {
  sm: {
    rootMarginBottom: "2px",
    rootPaddingBottom: "2px",
    inputFontSize: "12px",
    inputHeight: "14px",
    inputMarginRight: "8px",
    inputTop: "1px",
    inputWidth: "14px",
    inputFocusHeight: "14px",
    inputFocusWidth: "14px",
    inlineMarginRight: "16px",
    checkedHeight: "6px",
    checkedLeft: "3px",
    checkedTop: "3px",
    checkedWidth: "6px"
  },
  md: {
    rootMarginBottom: "6px",
    rootPaddingBottom: "2px",
    inputFontSize: "14px",
    inputHeight: "16px",
    inputMarginRight: "10px",
    inputTop: "2px",
    inputWidth: "16px",
    inputFocusHeight: "16px",
    inputFocusWidth: "16px",
    inlineMarginRight: "24px",
    checkedHeight: "6px",
    checkedLeft: "4px",
    checkedTop: "4px",
    checkedWidth: "6px"
  },
  lg: {
    rootMarginBottom: "14px",
    rootPaddingBottom: "1px",
    inputFontSize: "16px",
    inputHeight: "18px",
    inputMarginRight: "10px",
    inputTop: "3px",
    inputWidth: "18px",
    inputFocusHeight: "18px",
    inputFocusWidth: "18px",
    inlineMarginRight: "32px",
    checkedHeight: "8px",
    checkedLeft: "4px",
    checkedTop: "4px",
    checkedWidth: "8px"
  }
};

// components/radio/common/src/radio-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-radio";
var getRadioRootClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName);
};
var getRadioInputClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.input,
    overrideClasses && overrideClasses.input,
    `${globalClassName}__input`
  );
};
var getRadioContainerClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.container,
    overrideClasses && overrideClasses.container,
    `${globalClassName}__container`
  );
};
var getRadioInnerClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.inner,
    overrideClasses && overrideClasses.inner,
    `${globalClassName}__inner`
  );
};
var getRadioLabelClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.label,
    overrideClasses && overrideClasses.label,
    `${globalClassName}__label`
  );
};
var getRadioChildrenClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.children,
    overrideClasses && overrideClasses.children,
    `${globalClassName}__children`
  );
};

// components/radio/common/src/radio-group-service.ts
import { Injectable } from "@gs-ux-uitoolkit-common/shared";
var RadioGroupService = class {
  constructor() {
    this.groups = /* @__PURE__ */ new Map();
    this.checked = /* @__PURE__ */ new Map();
    if (instance) {
      return instance;
    }
    instance = this;
  }
  static get instance() {
    if (!instance) {
      instance = new RadioGroupService();
    }
    return instance;
  }
  addRadio(name, onClick) {
    if (!name) {
      return;
    }
    const group = this.groups.get(name) || /* @__PURE__ */ new Set();
    if (!this.groups.has(name)) {
      this.groups.set(name, group);
    }
    group.add(onClick);
  }
  removeRadio(name, onClick) {
    const group = this.groups.get(name);
    if (group && group.has(onClick)) {
      group.delete(onClick);
      if (group.size === 0) {
        this.groups.delete(name);
        this.checked.delete(name);
      }
    }
  }
  clickRadio(name, uid) {
    const group = this.groups.get(name);
    if (group) {
      group.forEach((onClick) => {
        onClick(uid);
      });
    }
  }
  markChecked(name, uid) {
    if (!name) {
      return;
    }
    this.checked.set(name, uid);
  }
  unmarkChecked(name, uid) {
    if (!name || uid !== this.checked.get(name)) {
      return;
    }
    this.checked.set(name, "");
  }
  getChecked(name) {
    return this.checked.get(name);
  }
  reset() {
    this.groups.clear();
  }
};
RadioGroupService = __decorateClass([
  Injectable()
], RadioGroupService);
var instance;

// components/radio/common/src/radio-uid.ts
var uidIndex = 0;
function getRadioUid() {
  return `gs-uitk-radio-${uidIndex++}`;
}
export {
  RadioGroupService,
  getRadioChildrenClasses,
  getRadioContainerClasses,
  getRadioInnerClasses,
  getRadioInputClasses,
  getRadioLabelClasses,
  getRadioRootClasses,
  getRadioUid,
  radioDefaultProps,
  radioSizes,
  radioStatuses,
  radioStyleSheet
};
//# sourceMappingURL=index.mjs.map
